module.exports = __webpack_public_path__ + "img/PKW_Bundespolizei.240bc851.svg";